module.exports = __webpack_public_path__ + "static/img/Km.03a23d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Km.png
// module id = jTJD
// module chunks = 0